import { render, staticRenderFns } from "./declinaison.vue?vue&type=template&id=124f47ba&"
import script from "./declinaison.vue?vue&type=script&lang=js&"
export * from "./declinaison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports